import React from 'react';
import Stack from '@mui/material/Stack';
import { useTranslation } from 'react-i18next';
import {
  CheckoutFormProps,
  DefaultFormActions,
  Form,
  useEnhancedForm,
} from '../../apiForm/form';
import { TextField } from '../../apiForm/form/input';
import ArrayWrapper from '../../apiForm/wrapper/ArrayWrapper';
// import CheckboxField from '../../apiForm/form/input/CheckboxField';
import ExpandableFieldset from '../../apiForm/form/ExpandableFieldset';

interface ReasonFieldsProps {
  index: number;
  control: any;
  type: 'payIn' | 'payOut';
}

function ReasonFields({ index, control, type }: ReasonFieldsProps) {
  const { t } = useTranslation();

  return (
    <Stack spacing={1}>
      <TextField
        control={control}
        name={`cashMovementConfiguration.${type}Reasons[${index}].name`}
        disabled={false}
        label={t('checkoutConfig.label.cash.reason.name')}
        helperText={t('checkoutConfig.helperText.cash.reason.name')}
      />
      <TextField
        control={control}
        name={`cashMovementConfiguration.${type}Reasons[${index}].code`}
        disabled={false}
        label={t('checkoutConfig.label.cash.reason.code')}
        helperText={t('checkoutConfig.helperText.cash.reason.code')}
      />
    </Stack>
  );
}

export default function CashForm({
  defaultValues = {},
  errors = {},
  onSubmit,
}: CheckoutFormProps<any>) {
  const { t } = useTranslation();
  const { handleSubmit, control, formState, getValues, reset } =
    useEnhancedForm({ defaultValues, errors });

  return (
    <Form onSubmit={handleSubmit(onSubmit)}>
      <ExpandableFieldset legend={t('checkoutConfig.legend.cash.reason.payIn')}>
        <ArrayWrapper
          control={control}
          name="cashMovementConfiguration.payInReasons"
          defaultValue={{}}
          addLabel={t('checkoutConfig.arrayWrapper.cash.reason.add')}
          removeLabel={t('checkoutConfig.arrayWrapper.cash.reason.remove')}
          render={(index: number) => (
            <ReasonFields index={index} control={control} type="payIn" />
          )}
        />
      </ExpandableFieldset>

      <ExpandableFieldset
        legend={t('checkoutConfig.legend.cash.reason.payOut')}
      >
        <ArrayWrapper
          control={control}
          name="cashMovementConfiguration.payOutReasons"
          defaultValue={{}}
          addLabel={t('checkoutConfig.arrayWrapper.cash.reason.add')}
          removeLabel={t('checkoutConfig.arrayWrapper.cash.reason.remove')}
          render={(index: number) => (
            <ReasonFields index={index} control={control} type="payOut" />
          )}
        />
      </ExpandableFieldset>

      <DefaultFormActions
        formState={formState}
        cancelNavigationTarget="/"
        noCancelNavigation
        reset={reset}
        getValues={getValues}
      />
    </Form>
  );
}
